<template>
  <landing-page></landing-page>
</template>

<script>
import LandingPage from './pages/LandingPage.vue'

export default {
  name: 'App',
  components: {
    LandingPage,
  }
}
</script>

<style lang="scss">

@font-face {
  font-family: 'Play';
  src: local('Play'), url('./assets/fonts/Play-Regular.ttf') format('truetype'),
}

@font-face {
  font-family: 'Play-Bold';
  src: local('Play-Bold'), url('./assets/fonts/Play-Bold.ttf') format('truetype'),
}

body, html {

  background:$background1;
  background-image:
      url('assets/images/mesh_blur6.png'),
      radial-gradient($background1, $background2);
  background-position: center;
  background-repeat: no-repeat;
  background-size:cover;
  color: $white;
  font-family: Play, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size:16px;
  margin:0px;
  padding:0px;
  overflow-x:hidden;
  width:100%;
}

h1 {
  font-family: Play, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size:40px;
  margin:0px 0px 20px 0px;
  padding:0px;
}

h2 {
  @extend h1;
  font-size:25px;
  margin:0px 0px 20px 0px;
}



</style>
